import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/"
        }}>{`Introduction`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/concepts"
            }}>{`Concepts`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/installation"
            }}>{`Installation`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/tutorial"
            }}>{`Tutorial`}</a></li>
        </ul></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/controls"
        }}>{`Controls`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/controls/default-timer"
            }}>{`Default timer`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/controls/pre-defined-types"
            }}>{`Pre-defined types`}</a><ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/react-sim/controls/checkbox"
                }}>{`Checkbox`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/react-sim/controls/toggle"
                }}>{`Toggle`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/react-sim/controls/radio"
                }}>{`Radio`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/react-sim/controls/select"
                }}>{`Select`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/react-sim/controls/input"
                }}>{`Input`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/react-sim/controls/range"
                }}>{`Range`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/react-sim/controls/timer"
                }}>{`Timer`}</a></li>
            </ul></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/controls/custom-controls"
            }}>{`Custom controls`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/controls/arranging-controls"
            }}>{`Arranging controls`}</a></li>
        </ul></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/time"
        }}>{`Time`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/frames"
        }}>{`Frames`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/frame-helpers"
            }}>{`Frame helpers`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/frame-helpers/canvas-frame"
            }}>{`Canvas Frame`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/frame-helpers/grid"
            }}>{`Grid`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/frame-helpers/time-series"
            }}>{`Time Series`}</a></li>
        </ul></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/api"
        }}>{`API Reference`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/examples"
        }}>{`Examples`}</a><ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/automata"
            }}>{`1D automata`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/activators"
            }}>{`Activators/inhibitors`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/model"
            }}>{`A Simple Model`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/boids"
            }}>{`Boids`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/chaos-game"
            }}>{`The Chaos Game`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/dice"
            }}>{`Dice simulator`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/epidemic"
            }}>{`Epidemic simulator`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/fibonacci"
            }}>{`Fibonacci sequence`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/game-of-life"
            }}>{`Game of Life`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/mazes"
            }}>{`Maze generation`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/percolation"
            }}>{`Percolation`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/segregation"
            }}>{`Segregation`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/react-sim/examples/snake"
            }}>{`Snake game`}</a></li>
        </ul></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      